import React from 'react';

const ArrowsDown = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.36607 12.7519C7.85423 12.2832 8.64575 12.2832 9.13391 12.7519L12 15.5033L14.8661 12.7519C15.3543 12.2832 16.1457 12.2832 16.6339 12.7519C17.122 13.2205 17.122 13.9803 16.6339 14.4489L12.8839 18.0489C12.3957 18.5175 11.6042 18.5175 11.1161 18.0489L7.36607 14.4489C6.87791 13.9803 6.87791 13.2205 7.36607 12.7519Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.36607 5.54866C7.85423 5.08006 8.64575 5.08006 9.13391 5.54866L12 8.30013L14.8661 5.54866C15.3543 5.08006 16.1457 5.08006 16.6339 5.54866C17.122 6.01738 17.122 6.7771 16.6339 7.24582L12.8839 10.8458C12.3957 11.3144 11.6042 11.3144 11.1161 10.8458L7.36607 7.24582C6.87791 6.7771 6.87791 6.01738 7.36607 5.54866Z",
      fill: "currentColor"
    }
  )
);
ArrowsDown.displayName = "Icons.ArrowsDown";

export { ArrowsDown };
//# sourceMappingURL=ArrowsDown.js.map
